

<template>
  <mdb-container>
    <mdb-col>
      <div class="mt-5 sub_content">
        <h3>공지 사항</h3>
      </div>
      <div class="my-3">
        <mdb-tbl reponsive>
          <mdb-tbl-head style="background-color: #ececec;">
            <tr>
              <th colspan="4" style="font-size: 20px;">{{ title }}</th>
            </tr>
          </mdb-tbl-head>
          <mdb-tbl-body>
            <tr>
              <th>등록일</th>
              <td colspan="3">{{ reg_date }}</td>
            </tr>
            <tr>
              <th>작성자</th>
              <td>{{ writer }}</td>
              <th>조회수</th>
              <td>{{ views }}</td>
            </tr>
            <tr>
              <th style="vertical-align: middle">파일</th>
              <td colspan="3">
                <ul>
                  <li v-if="file_name !== ''">
                    <a :href="file_name"> {{ file_url }}</a>
                  </li>
                </ul>
              </td>
            </tr>
            <tr>
              <td colspan="4" style="text-align: center">
                <div v-if="image_url !== ''">
                  <img :src="image_url" alt="img" style="max-width: 100%">
                </div>
                <div class="my-3" v-if="contents !== ''">
                  {{ contents }}
                </div>
              </td>
            </tr>
          </mdb-tbl-body>
        </mdb-tbl>
      </div>
    </mdb-col>
  </mdb-container>
</template>

<script>
import {mdbCol, mdbContainer, mdbTbl, mdbTblBody, mdbTblHead} from 'mdbvue';
import firebase from "firebase/app";

export default {
  name: "NoticeView",
  data() {
    return {
      id: this.$route.query.id,
      contents: '',
      files: [],
      image_url: '',
      order_number: 0,
      reg_date: '',
      title: '',
      views: 0,
      writer: '',
      file_name: '',
      file_url: '',
    }
  },
  components: {
    mdbContainer,
    mdbTblHead,
    mdbCol,
    mdbTbl,
    mdbTblBody
  },
  mounted() {
    this.onFirebaseLoadData();
    this.setViewCountAdd();
  },
  methods: {
    setViewCountAdd() {
      const self = this;
      const db = firebase.firestore();

      const docRef = db.collection('notice').doc(self.id);

      db.runTransaction((transaction) => {
        return transaction.get(docRef).then((sfDoc) => {
          if (!sfDoc.exists) {
            throw "Document does not exist!";
          }
          const newViews = sfDoc.data().views + 1;
          if (newViews <= 1000000) {
            transaction.update(docRef, {views: newViews});
            return newViews;
          } else {
            return Promise.reject("Sorry! Population is too big.");
          }
        });
      }).then((newViews) => {
        console.log("Population increased to ", newViews);
      }).catch((err) => {
        // This will be an "population is too big" error.
        console.error(err);
      });
    },
    onFirebaseLoadData() {
      const db = firebase.firestore();
      const self = this;

      db.collection("notice")
          .doc(self.id).get().then(function (querySnapshot) {
        const _data = querySnapshot.data();
        self.contents = _data.contents;
        if (!self.isEmpty(_data.files)) {
          self.files = Object.entries(_data.files);
          self.file_url = Object.entries(_data.files)[0][0];
          self.file_name = Object.entries(_data.files)[0][1];
        }
        self.image_url = _data.image_url;
        self.order_number = _data.order_number;
        const date = new Date(_data.reg_date.seconds * 1000);
        self.reg_date = self.getParseDate(date);
        self.title = _data.title;
        self.views = _data.views;
        self.writer = _data.writer;
      });
    },
    isEmpty(param) {
      return Object.keys(param).length === 0;
    },
    getParseDate(date) {
      return date.getFullYear() +
          "-" + (date.getMonth() + 1) +
          "-" + date.getDate() +
          " " + date.getHours() +
          ":" + date.getMinutes() +
          ":" + date.getSeconds()
    }
  }
}
</script>

<style scoped>

.sub_content {
  text-align: center;
}

.sub_content h3 {
  font-weight: bold;
}

th {
  background-color: #ececec;
}

ul {
  list-style: none;
  margin: 0;
  padding: 0;
}
</style>
